import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/cbsReports'
import context from '@/context'
import { localized } from '@/decorators/localized'
import { DataLoader } from '@/components/dataLoader'
import { CbsReportsContent } from './content'

@localized()
class DownloadCbsReportButton extends React.Component {
  getCbsReports = () => {
    return context.api.individualService.getLatestCbsReports(this.props.individualId)
  }
  render () {
    return (
      <DataLoader
        key={this.props.cbsReports.downloaderKey}
        dataSource={this.getCbsReports}
        render={({ data: reports, loading }) => <CbsReportsContent
          reports={reports}
          localize={this.props.localize}
          loading={loading}
          fetching={this.props.cbsReports.fetching}
          downloadCbsReport={this.props.downloadCbsReport}
          individualId={this.props.individualId} />}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  cbsReports: state.cbsReports,
  ...ownProps
})

const mapDispatchToProps = {
  downloadCbsReport: actionCreators.downloadCbsReport
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadCbsReportButton)



// WEBPACK FOOTER //
// ./src/internal-app/pages/individuals/cbsReports/index.js